/* eslint-disable import/no-named-as-default-member */
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import objectSupport from 'dayjs/plugin/objectSupport'
import toObject from 'dayjs/plugin/toObject'
import isToday from 'dayjs/plugin/isToday'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

// Import all locales
import 'dayjs/locale/bg'
import 'dayjs/locale/cy'
import 'dayjs/locale/de'
import 'dayjs/locale/de-ch'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/es'
import 'dayjs/locale/et'
import 'dayjs/locale/fr'
import 'dayjs/locale/ga'
import 'dayjs/locale/gu'
import 'dayjs/locale/hi'
import 'dayjs/locale/hu'
import 'dayjs/locale/lt'
import 'dayjs/locale/lv'
import 'dayjs/locale/nl'
import 'dayjs/locale/pl'
import 'dayjs/locale/ro'
import 'dayjs/locale/sk'
import 'dayjs/locale/tr'
import 'dayjs/locale/uk'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'

dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(objectSupport)
dayjs.extend(toObject)
dayjs.extend(isToday)
dayjs.extend(isSameOrAfter)

// Map vue-i18n locale codes to dayjs locale codes
const localeMap: Record<string, string> = {
  bg: 'bg',
  cy: 'cy',
  de: 'de',
  de_CH: 'de-ch',
  en: 'en-gb',
  es: 'es',
  et: 'et',
  fr: 'fr',
  ga: 'ga',
  gu: 'gu',
  hi: 'hi',
  hu: 'hu',
  lt: 'lt',
  lv: 'lv',
  nl: 'nl',
  pl: 'pl',
  ro: 'ro',
  sk: 'sk',
  tr: 'tr',
  uk: 'uk',
  zh_CN: 'zh-cn',
  zh_TW: 'zh-tw',
}

// Function to set dayjs locale based on vue-i18n locale
export function setDayjsLocale(i18nLocale: string): void {
  const dayjsLocale = localeMap[i18nLocale] || 'en-gb'

  dayjs.locale(dayjsLocale)
}

// Initialize with locale from localStorage or default to 'en'
const storedLocale = localStorage.getItem('locale') || 'en-gb'

setDayjsLocale(storedLocale)

export default dayjs
